var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBorderPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UIKit",
    transform: "translate(-1267.000000, -1328.000000)",
    fill: "#A5BFCE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Form/Input/Date",
    transform: "translate(950.000000, 1291.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.749972,44.5000155 L328.749972,45.5000131 C328.749972,45.7062504 328.58121,45.8750122 328.374973,45.8750122 L325.624979,45.8750122 L325.624979,48.6250057 C325.624979,48.831243 325.456218,49.0000048 325.24998,49.0000048 L324.249983,49.0000048 C324.043745,49.0000048 323.874984,48.831243 323.874984,48.6250057 L323.874984,45.8750122 L321.12499,45.8750122 C320.918753,45.8750122 320.749991,45.7062504 320.749991,45.5000131 L320.749991,44.5000238 C320.749991,44.2937782 320.918753,44.1250164 321.12499,44.1250164 L323.874984,44.1250164 L323.874984,41.3750229 C323.874984,41.1687856 324.043745,41.0000238 324.249991,41.0000238 L325.24998,41.0000238 C325.456218,41.0000238 325.624979,41.1687856 325.624979,41.3750229 L325.624979,44.1250164 L328.374973,44.1250164 C328.58121,44.1250164 328.749972,44.2937782 328.749972,44.5000155 Z M332.499963,45.0000143 C332.499963,49.2812541 329.031221,52.7499958 324.749982,52.7499958 C320.468742,52.7499958 317,49.2812541 317,45.0000143 C317,40.7187745 320.468742,37.2500328 324.749982,37.2500328 C329.031221,37.2500328 332.499963,40.7187745 332.499963,45.0000143 Z M330.999967,45.0000143 C330.999967,41.5468975 328.203098,38.7500292 324.749982,38.7500292 C321.296865,38.7500292 318.499996,41.5468975 318.499996,45.0000143 C318.499996,48.4531311 321.296865,51.2499994 324.749982,51.2499994 C328.203098,51.2499994 330.999967,48.4531311 330.999967,45.0000143 Z",
    id: "\\uF055"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderPlus);
export default __webpack_public_path__ + "static/media/border-plus.21aa9f7d.svg";
export { ForwardRef as ReactComponent };